import { useKeycloak } from "@react-keycloak/web";
import AccessRoute from "./AccessRoute";

const PrivateRoute = (props: any) => {
  const { keycloak } = useKeycloak();
  const { children } = props;
  const emailDomain = keycloak.idTokenParsed?.email?.split(`@`)[1];

  return keycloak && keycloak.authenticated && emailDomain === 'korewireless.com' ? children : <AccessRoute />;
};

export default PrivateRoute;

